import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    activeTab: any;
}

const TabPanel: FunctionComponent<TabPanelProps> = (props) => {
    const { children, activeTab, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={activeTab !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            className="fullHeight"
            {...other}
        >
            {activeTab === index && (
                <Box height="100%" p={3}>
                    <Typography component="div" className="fullHeight">
                        {children}
                    </Typography>
                </Box>
            )}
        </div>
    );
};

export default TabPanel;
